/**
 * Feature flag fetch over the typed `@tiaki/http-client` per ADR 113
 * §Decision (the typed-call-site DX win).
 */
import { client } from '../lib/http-client';
import type { SiteFeatures } from '../types/licensing';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  const __resp = result as { error?: unknown }; if (__resp.error !== undefined) throw __resp.error;
  return result.data as T;
}

/**
 * Fetch pre-computed feature enabled states for all user's sites.
 */
export async function getFeatureEnabled(): Promise<SiteFeatures[]> {
  const result = await client.GET('/api/v2/feature/enabled', {});
  return unwrap(result) as unknown as SiteFeatures[];
}
